import { Injectable, inject } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class TranslationService {
    private translateService = inject(TranslateService);

    private locale = 'fr';

    constructor() {
        this.locale = this.translateService.currentLang;
        this.translateService.onLangChange.subscribe((res: { lang: string }) => this.locale = res.lang);
    }

    public getTranslation(item: any = null, locale: string = null) {
        if (item === null) {
            return null;
        }

        const loc = locale ?? this.locale;
        const translations = item?.translations;
        if (!translations) {
            return item;
        }

        return translations.find(trans => trans['locale'] && trans['locale'] == loc);
    }

    public getPropertyTranslation(item: any, propertyKey: string, locale: string = null): string {
        const loc = locale ?? this.locale;

        const translation = this.getTranslation(item, loc);
        if (translation && translation[propertyKey] && translation[propertyKey] != '') {
            return translation[propertyKey];
        }

        return '';
    }

    public getTranslationWithFallback(item: any = null, locale: string = null) {
        const loc = locale ?? this.locale;

        const translation = this.getTranslation(item, loc);
        if (translation) {
            return translation;
        }

        const fallBackLocale = (loc != 'en') ? 'en' : 'fr';
        return this.getTranslation(item, fallBackLocale);
    }

    public getPropertyTranslationWithFallback(item: any, propertyKey: string, locale: string = null): string {
        const loc = locale ?? this.locale;

        const translation = this.getPropertyTranslation(item, propertyKey, loc);
        if (translation && translation != '') {
            return translation;
        }

        const fallBackLocale = (loc != 'en') ? 'en' : 'fr';
        return this.getPropertyTranslation(item, propertyKey, fallBackLocale);
    }
}
